export const calculateAge = (isoDateString: string): number => {
  const birthDate = new Date(isoDateString);
  if (Number.isNaN(birthDate.getTime())) return NaN;
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());
  if (!hasHadBirthdayThisYear) age--;
  return age;
};

export const isValidDate = (isoDateString: string): boolean => {
  if (!isoDateString) return false;
  // Expecting format YYYY-MM-DD or a valid ISO date string
  // Quick YYYY-MM-DD check to avoid timezone parsing surprises
  const ymdMatch = /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(isoDateString);

  if (!ymdMatch) return false;

  const [yearStr, monthStr, dayStr] = isoDateString.split("-");
  const year = Number(yearStr);
  const monthIndex = Number(monthStr) - 1; // 0-based month
  const day = Number(dayStr);

  if (year < 1900 || monthIndex < 0 || monthIndex > 11 || day < 1 || day > 31) return false;

  const d = new Date(Date.UTC(year, monthIndex, day));
  return d.getUTCFullYear() === year && d.getUTCMonth() === monthIndex && d.getUTCDate() === day;
};
